/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ToolUsageTargetToolBreakdownRow,
  ToolUsageTargetToolBreakdownRow$inboundSchema,
} from "./toolusagetargettoolbreakdownrow.js";

/**
 * Per-tool MCP and tool usage grouped by target
 */
export type GetToolUsageTargetToolBreakdownResult = {
  /**
   * Per-tool usage rows grouped by target
   */
  targetToolBreakdown: Array<ToolUsageTargetToolBreakdownRow>;
};

/** @internal */
export const GetToolUsageTargetToolBreakdownResult$inboundSchema: z.ZodMiniType<
  GetToolUsageTargetToolBreakdownResult,
  unknown
> = z.pipe(
  z.object({
    target_tool_breakdown: z.array(
      ToolUsageTargetToolBreakdownRow$inboundSchema,
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "target_tool_breakdown": "targetToolBreakdown",
    });
  }),
);

export function getToolUsageTargetToolBreakdownResultFromJSON(
  jsonString: string,
): SafeParseResult<GetToolUsageTargetToolBreakdownResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetToolUsageTargetToolBreakdownResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetToolUsageTargetToolBreakdownResult' from JSON`,
  );
}
